import React from 'react'

import { SvgProps } from './types'

function Eye3SlashSvg({
  width,
  height,
  className,
  stroke,
  strokeColor,
}: SvgProps) {
  return (
    <svg
      className={className}
      width={width || '48'}
      height={height || '48'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      stroke={strokeColor}
      fill="none"
      strokeWidth={stroke || 1.6}
    >
      <path
        d="M3 3L17 17M8.83333 8.971C8.57127 9.26773 8.4322 9.65321 8.44446 10.0489C8.45673 10.4446 8.6194 10.8207 8.89933 11.1007C9.17926 11.3806 9.5554 11.5433 9.95109 11.5555C10.3468 11.5678 10.7323 11.4287 11.029 11.1667"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.39267 6.54712C5.08444 7.46412 3.99478 8.77079 3 9.99967C4.46922 12.326 7.10822 14.6663 10 14.6663C11.2056 14.6663 12.3668 14.2596 13.4183 13.6163M10 5.33301C13.1173 5.33301 15.2119 7.78923 17 9.99967C16.7437 10.4047 16.4638 10.7943 16.1616 11.1663"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Eye3SlashSvg
